import { PlusOutlined } from "@ant-design/icons";

export const uploadButton = (
  <button style={{ border: 0, background: "none", cursor: "pointer" }} type="button">
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Last opp</div>
  </button>
);
